import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useState } from "react";
import { Input } from "@/components/ui/input";
import MixAndMatchListTable from "./mix-and-match-list-table";
import Paginat from "@/components/lib/paginat";
import { Search } from "lucide-react";
import { TabsContent } from "@/components/ui/tabs";
import { useSelector } from "react-redux";
import { useFilter } from "@/hooks/useFilter";
import { useSearch } from "@/hooks/useSearch";
import { usePagination } from "@/hooks/usePagination";

function MixAndMatchListTabs() {
  const { mixAndMatches } = useSelector((state) => state.menuManage.mixAndMatch);

  const [filters, setFilters] = useState({
    status: "",
  });
  const [searchText, setSearchText] = useState("");
  const [perPage, setPerPage] = useState(10);

  const filteredData = useFilter(mixAndMatches, filters, {
    delay: 300,
    defaultFilter: (item) =>
      item.status !== "draft" &&
      (filters.status === "archived"
        ? item.status === "archived"
        : item.status !== "archived"),
  });

  const searchData = useSearch(
    filteredData,
    searchText,
    ["id", "name"],
    300
  );

  const { paginatedData, paginationInfo, onPageChange } = usePagination(
    searchData,
    perPage
  );

  return (
    <TabsContent value="mix-match-list">
      <div className="mt-5">
        <div className="w-full flex justify-between lg:flex-row flex-col gap-4 items-start lg:items-center">
          <div className="w-full sm:w-[280px]">
            <div className="relative">
              <Search
                size={18}
                className="text-cwhite3 absolute top-2.5 left-3"
              />
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search by Name or ID..."
                className="bg-cblack3 pl-9 border-cblack6"
              />
            </div>
          </div>
          <div className="flex gap-3 justify-end items-center flex-wrap">
            <div className="relative">
              <Select
                onValueChange={(value) =>
                  setFilters((prev) => ({
                    ...prev,
                    status: value === "0" ? "" : value,
                  }))
                }
              >
                <SelectTrigger className="w-[120px] bg-cblack3 border-cblack6">
                  <SelectValue placeholder="Status" />
                </SelectTrigger>
                <SelectContent className="bg-cblack3 border-cblack6 text-cwhite">
                  <SelectItem value="0">All Status</SelectItem>
                  <SelectItem value="active">Active</SelectItem>
                  <SelectItem value="inactive">Inactive</SelectItem>
                  <SelectItem value="archived">Archived</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="flex gap-2 items-center text-sm text-cwhite2">
              <span>Show</span>
              <Select
                onValueChange={(value) => setPerPage(Number(value))}
                value={perPage.toString()}
              >
                <SelectTrigger className="w-[70px] bg-cblack3 border-cblack6">
                  <SelectValue placeholder="10" />
                </SelectTrigger>
                <SelectContent className="bg-cblack3 border-cblack6 text-cwhite">
                  <SelectGroup>
                    <SelectItem value="10">10</SelectItem>
                    <SelectItem value="20">20</SelectItem>
                    <SelectItem value="50">50</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <MixAndMatchListTable mixAndMatches={paginatedData} />
        </div>

        <div>
          <Paginat
            pagination={paginationInfo}
            onPageChange={onPageChange}
            className="mt-4"
          />
        </div>
      </div>
    </TabsContent>
  );
}

export default MixAndMatchListTabs;
